<template>
  <div
    ref="menu"
    :class="fullCssClass"
    :style="fullStyle"
  >
    <ul
      ref="dropdown"
      class="dropdown"
    >
      <li>
        <a :href="rootedUrl('')"><strong>Home</strong></a>
      </li>
      <li>
        <a href="https://pg.nybg.org"><strong>Perennial Garden</strong></a>
      </li>
      <li>
        <a :href="rootedUrl('/conservatory/')"><strong>Palm Dome</strong></a>
      </li>
      <li>
        <router-link :to="{name: 'burle-marx-intro'}">
          <strong>The Living Art of Roberto Burle Marx</strong>
        </router-link>
        <ul>
          <li>
            <router-link :to="{name: 'burle-marx-garden-map'}">
              Garden Map
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'burle-marx-create'}">
              Create Like Roberto Burle Marx
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'burle-marx-grow'}">
              Grow Like Roberto Burle Marx
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'burle-marx-live'}">
              Live Like Roberto Burle Marx
            </router-link>
          </li>
          <li>
            <router-link :to="{name: 'burle-marx-credits'}">
              Credits
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
    name: 'DropdownMenu',
    props: {
        top: {
            type: Number,
            default: 0
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
      fullCssClass() {
          return 'menu' + (this.visible ? ' is-active' : '')
      },
      topPx() {
          return '' + this.top + 'px'
      },
      fullStyle() {
          return {
              top: this.topPx
          }
      }
    },
    methods: {
        testclick(e) {
            console.log('Click', e.target.innerText)
        },
        rootedUrl(url) {
          return process.env.VUE_APP_EXPERIENCE_ROOT + url
        }
    }
}
</script>

<style lang="scss" scoped>
.menu {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  max-width: 100%;
  width: 30em;
  transform: translateX(100%);
  transition: transform .3s ease-out;
  pointer-events: none;
  &.is-active {
      transform: translateX(0%);
  }
  z-index: 1;
}
.dropdown {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #333;
  color: #eee;
  overflow: auto;
  padding: 1em;
  pointer-events: all;
  z-index: 20;
  margin: 0
}

ul {
  text-align: left;
  list-style: none;
  margin-left: 0.5rem;
  li {
  }
  a {
    display: block;
    margin-bottom: 1rem;
    color: white;
    text-decoration: none;
  }
}

ul {
  text-align: left;
  list-style: none;
  margin-left: 0.5rem;
  li {
  }
  a {
    display: block;
    margin-bottom: 1rem;
    color: white;
    text-decoration: none;
  }
}
</style>
